/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASEURL } from "../../../utilites";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../Store/action";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const ChangePassword = ({
  setStep,
  data,
  user,
  isAppointmentBooked,
  license,
  questionnaireState,
  isVerify,
  taxpro_allow_appointments,
  isMessageSent,
  isPdfDownloaded
}) => {
  const [{ profile }] = useSelector((state) => [state.dashboard]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const [alert, setAlert] = useState({
    password: false,
    newPassword: false,
    passwordRepeat: false,
    class: "danger",
    general: "",
  });

  const endpoint = `${BASEURL}/api/auth/profile/reset-password/${data.uuid}`;
  const passwordsMatch = newPassword && repeatPassword && newPassword === repeatPassword;

  const updateProfile = () => {
    const profileObj = {
      settings: {
        ...user?.LoginData?.settings,
        isPasswordChanged: true,
      },
    };
    dispatch(
      allActions.dashboard.updateProfile({
        uuid: user?.LoginData?.uuid,
        profileObj,
      })
    );
  };

  const handleFormSubmission = (e) => {
    e.preventDefault();

    if (!passwordsMatch) {
      setAlert({
        class: "danger",
        general: "Passwords do not match!",
      });
      return;
    }

    setLoading(true);
    axios
      .post(endpoint, {
        password: "",
        newPassword,
        passwordRepeat: repeatPassword,
      })
      .then((response) => {
        updateProfile();
        if (response.data.success && response.data.message !== "") {
          setAlert({
            class: "success",
            general: response.data.message,
          });
        }
        setTimeout(() => {
const appointmentOk = !taxpro_allow_appointments || isAppointmentBooked;

if (!isVerify) {
  setStep((prev) => prev + 1);
  return;
}

if (isVerify && !appointmentOk) {
  // appointments ARE allowed but NOT booked yet → go to booking step
  setStep((prev) => prev + 2);
  navigate(
    `?lead=${user?.LoginData?.lead[0]?.uuid}&customer=${user?.LoginData?.uuid}&operator=${user?.LoginData?.lead[0]?.userpro?.uuid}`,
    { replace: true }
  );
  return;
}

if (isVerify && appointmentOk && !license) {
  setStep((prev) => prev + 3);
  return;
}

if (
  isVerify &&
  appointmentOk &&
  license &&
  questionnaireState.value !== questionnaireState.max
) {
  setStep((prev) => prev + 4);
  return;
}

if (
  isVerify &&
  appointmentOk &&
  license &&
  questionnaireState.value === questionnaireState.max &&
  !isMessageSent
) {
  setStep((prev) => prev + 5);
  return;
}

if (
  isVerify &&
  appointmentOk &&
  license &&
  questionnaireState.value === questionnaireState.max &&
  isMessageSent &&
  !isPdfDownloaded
) {
  setStep((prev) => prev + 6);
  return;
}

if (
  isVerify &&
  appointmentOk &&
  license &&
  questionnaireState.value === questionnaireState.max &&
  isMessageSent &&
  isPdfDownloaded
) {
  setStep((prev) => prev + 7);
  return;
}

        }, 2000);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
        setAlert({
          class: "danger",
          general: error?.response?.data?.error || "Something went wrong",
        });
      });
  };

  useEffect(() => {
    if (profile?.state === true) {
      dispatch(allActions.user.ReGetUserData());
    }
  }, [profile.state]);

  return (
    <div className="d-flex justify-content-center align-items-center px-3 py-2 bg-white">
      <div className="w-100">
        <h2 className="text-center fw-bold mb-2" style={{ color: "#4a4fff" }}>
          Create Password
        </h2>
        <p className="text-center text-muted mb-4">
          Keep your account safe with a password
        </p>

        <div className="m-auto" style={{ width: "100%", maxWidth: "400px" }}>
          {alert.general && (
            <div className={`alert alert-${alert.class} text-center`} role="alert">
              {alert.general}
            </div>
          )}

          {/* New Password */}
          <div className="mb-4">
            <label className="form-label fw-semibold text-black fs-6">New Password</label>
            <div className="position-relative">
              <input
                type={showNewPassword ? "text" : "password"}
                className="form-control bg-grey-100 border-0 rounded-3 py-4 ps-3 pe-5"
                placeholder="Enter your new password here"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              {showNewPassword ? (
                <AiOutlineEyeInvisible
                  size={20}
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "16px",
                    transform: "translateY(-50%)",
                    color: "#888",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowNewPassword(false)}
                />
              ) : (
                <AiOutlineEye
                  size={20}
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "16px",
                    transform: "translateY(-50%)",
                    color: "#888",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowNewPassword(true)}
                />
              )}
            </div>
            <small className="text-muted d-block mt-2" style={{ fontSize: "13px" }}>
              Your password must be at least 8 characters<br />
              Use a strong password with a mix of letters, numbers, and symbols, avoiding personal info.
            </small>
          </div>

          {/* Confirm Password */}
          <div className="mb-4">
            <label className="form-label fw-semibold text-black fs-6">Confirm Password</label>
            <div className="position-relative">
              <input
                type={showRepeatPassword ? "text" : "password"}
                className="form-control bg-grey-100 border-0 rounded-3 py-4 ps-3 pe-5"
                placeholder="Repeat your new password here"
                value={repeatPassword}
                onChange={(e) => setRepeatPassword(e.target.value)}
              />
              {showRepeatPassword ? (
                <AiOutlineEyeInvisible
                  size={20}
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "16px",
                    transform: "translateY(-50%)",
                    color: "#888",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowRepeatPassword(false)}
                />
              ) : (
                <AiOutlineEye
                  size={20}
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "16px",
                    transform: "translateY(-50%)",
                    color: "#888",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowRepeatPassword(true)}
                />
              )}
            </div>
          </div>

        </div>
         <div className="d-flex justify-content-between w-100 pt-2">
            <button
              className="btn btn-outline-primary d-flex align-items-center gap-2 px-4"
              onClick={() => setStep((prev) => prev - 1)}
              disabled={loading}
            >
              <FiArrowLeft /> Back
            </button>

            <button
              className="btn btn-primary d-flex align-items-center gap-2 px-4 text-white"
              disabled={!passwordsMatch || loading}
              onClick={handleFormSubmission}
              style={{
                opacity: !passwordsMatch || loading ? 0.7 : 1,
                backgroundColor: "#4a4fff",
                borderRadius: "10px",
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Loading...
                </>
              ) : (
                <>
                  Next Step <FiArrowRight />
                </>
              )}
            </button>
          </div>
      </div>
    </div>
  );
};

export default ChangePassword;
